import { Route } from "@angular/router";
import { DashboardPage } from "./dashboard.page";

export const DashboardRouter: Route[] = [
  { path: 'dashboard', component: DashboardPage }
];
